import {ListVehicleFinancingTemplateResponseBody} from '@dms/api/sales';

const LAST_POSITION = Number.MAX_SAFE_INTEGER;

/**
 * Orders the templates of one type the way the automatic assignment evaluates them: by automatic
 * position first (templates without one sort last), then by name.
 */
export function getOrderedVehicleFinancingTemplates(
  templates: ListVehicleFinancingTemplateResponseBody[],
  type: ListVehicleFinancingTemplateResponseBody['type']
): ListVehicleFinancingTemplateResponseBody[] {
  return templates
    .filter((template) => template.type === type)
    .sort(
      (left, right) =>
        (left.automaticPosition ?? LAST_POSITION) - (right.automaticPosition ?? LAST_POSITION) ||
        left.name.localeCompare(right.name)
    );
}
